// extracted by mini-css-extract-plugin
module.exports = {"debugMode":"DebugButton_debugMode__Whuab","debugIcon":"DebugButton_debugIcon__2h3Bo","active":"DebugButton_active__2mC8d"};